import React from 'react'
import { borderRadius, whiteCard } from '../../common/cssclasses'
import { useTranslate } from '../TranslationText';
import NetaqInput from '../NetaqInput';
import NewActionButton from '../ActionButtons/NewActionButton';

export default function NewsFilter({ filter = {}, setFilter = () => { }, doFilter = () => { } }) {
    const { translate } = useTranslate();

    const handleChange = (event) => {
        setFilter((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    }

   

    return (
        <form className={whiteCard + borderRadius} onReset={(e) => {setFilter({}); doFilter({})}} onSubmit={(e) => { e.preventDefault(); doFilter() }} >
            <h3 className='text-start fw-bold'>{translate('web.advancedSearch', 'Advanced Search')}</h3>
            <div className="col-sm-12 mt-2">
                <NetaqInput
                    type={'text'}
                    name={'title'}
                    label={translate('web.newsTitle', 'News Title')}
                    onChange={handleChange}
                />
            </div>
            <div className='row'>
                <div className="col-sm-6 mt-2">
                    <NetaqInput
                        type={'normalDate'}
                        name={'dateFrom'}
                        label={translate('web.dateFrom', 'Date From')}
                        onChange={handleChange}

                    />
                </div>
                <div className="col-sm-6 mt-2">
                    <NetaqInput
                        type={'normalDate'}
                        name={'dateTo'}
                        label={translate('web.dateTo', 'Date To')}
                        onChange={handleChange}
                        minDate={filter?.dateFrom}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-sm-6 mt-2">
                    <NewActionButton isButton text={translate('web.reset', 'reset')} type='reset' />
                </div>
                <div className="col-sm-6 mt-2">
                    <NewActionButton isButton classNames='btn-success' text={translate('web.search', 'search')} />

                </div>
            </div>
        </form>
    )
}
